export default "__VITE_ASSET__DKminWzj__"